import { useCallback, useState } from 'react';
import { ModalOptions } from '../types';
import { ListModalContext } from './ListModalContext';

export const ListModalContextProvider: React.FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [listModalOptions, setListModalOptions] = useState<ModalOptions>();
  const closeModal = useCallback(() => {
    setListModalOptions(undefined);
  }, []);

  const value = {
    showListModalOptions: setListModalOptions,
    listModalOptions,
    closeModal,
  };

  return <ListModalContext.Provider value={value}>{children}</ListModalContext.Provider>;
};
